import _ from "lodash";
import { Select, TableColumnsType } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getExamLevels } from '../../../api/statistics.api';
import useAxios from '../../../hooks/useAxios';
import {
  IExamStatsByQuestion,
  IExamStatsByQuestionBySkill,
  IGetExamLevels,
} from '../../../models/statistics.model';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import ExamQuestionTable from './ExamQuestionTable';
import SelectExamSubject from '../SelectExamSubject';
import DownloadButton from "../../DownloadButton";
import moment from "moment";
import exportTitleTable from "../../../lib/exportTitleTable";
import { openTestResults } from "../../../api/tutor.api";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { getDetailCode, getDetailCodeLabel } from "../../../lib/util";
import Radio from "../../Radio";
import ExamQuestioneGraph from "./ExamQuestionGraph";
import Button from "../../Button";

export enum EResultType {
  Table,
  Graph,
};

interface IProps {
  data: IExamStatsByQuestion[] | undefined;
  examCode: number | undefined;
  semesterCode: number | undefined;
  examSubjectCode: number | undefined;
  setExamSubjectCode: (examSubjectCode: number | undefined) => void;
  courseCode: number | undefined;
  setCourseCode: (courseCode: number | undefined) => void;
}

const ExamStatsByQuestion: FC<IProps> = ({
  data,
  examCode,
  semesterCode,
  examSubjectCode,
  setExamSubjectCode,
  courseCode,
  setCourseCode,
}) => {
  const { t } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  const TE0001 = getDetailCode(commonCodes, 'TE0001');
  const { data: res, isLoading, error, execute } = useAxios<IGetExamLevels>();
  const [selCourseList, setSelCourseList] = useState<IGetExamLevels>();
  const [resData, setResData] = useState<IExamStatsByQuestionBySkill[]>([]);
  const [testStudents, setTestStudents] = useState<number>(0);
  const [testPaper, setTestPaper] = useState<string>('');
  const [courseName, setCourseName] = useState<string>('');
  const [examSubjectName, setExamSubjectName] = useState<string>('');
  const [excelExamDiv, setExcelExamDiv] = useState<string>('');
  const [excelSemesterName, setExcelSemesterName] = useState<string>('');
  const [excelExamTypeName, setExcelExamTypeName] = useState<string>('');
  const [excelMonthNameCode, setExcelMonthNameCode] = useState<string>('');
  const [resultType, setResultType] = useState<EResultType>(EResultType.Table);

  useEffect(() => {
    setSelCourseList(undefined);

    if (examCode && semesterCode) {
      execute(getExamLevels(examCode, semesterCode));
    }
  }, [examCode, semesterCode]);

  useEffect(() => {
    let _data: any = _.cloneDeep(res);
    setSelCourseList(_data);
  }, [res]);

  useEffect(() => {
    //let tempData: any = _.cloneDeep(data);
    let tempData: IExamStatsByQuestionBySkill[] = [];
    let tempTestStudents: number = 0;
    let tempTestPaper: string = '';
    let tempIdx: number = 1;
    let tempExamDiv: string = '';
    let tempSemesterName: string = '';
    let tempExamTypeName: string = '';
    let tempMonthNameCode: string = '';

    if (data) {
      if(data.length) {
        data.forEach((item: any) => {
          if(item.skillInfo?.length) {
            item.skillInfo?.map((subItem:any)=>{
              let newItem: any = {};

              newItem.rowIdx = tempIdx++;
              newItem.indicator = item.indicatorKorName + '(' + item.indicatorEngName + ')';
              newItem.skillName = subItem.skillName;
              newItem.totalQs = subItem.totalQs;
              //newItem.correctAnswer = subItem.correctAnswer;
              //newItem.incorrectAnswer = subItem.incorrectAnswer;
              newItem.correctAnswerRate = subItem.correctAnswerRate;
              tempData.push(newItem);
            });
          }

          //시험 학생 수
          if(!tempTestStudents) {
            tempTestStudents = item.testStudents;
          }

          //EDUBASE 시험지 명
          if(!tempTestPaper) {
            tempTestPaper = item.testPaper + '(code : ' + item.testPaperCode + ')';
          }

          //시험 구분
          if(!tempExamDiv) {
            tempExamDiv = item.examDiv;
            if(item.examDiv === 'MT') {
              if(item.eduStepCode === 'MD') {
                tempExamDiv = 'PL'
              }
            }
          }

          //학기
          if(!tempSemesterName) {
            tempSemesterName = item.semesterName;
          }

          //시험타입
          if(!tempExamTypeName) {
            tempExamTypeName = item.examTypeName;
          }

          //월
          if(!tempMonthNameCode) {
            tempMonthNameCode = item.monthNameCode;
          }
          
        });
      }
    }

    setTestStudents(tempTestStudents);
    setTestPaper(tempTestPaper);
    setResData(tempData);
    setExcelExamDiv(getDetailCodeLabel(TE0001, tempExamDiv));
    setExcelSemesterName(tempSemesterName);
    setExcelExamTypeName(tempExamTypeName);
    setExcelMonthNameCode(tempMonthNameCode);
  }, [data]);


  const getColumns = () => {
    const mainColumns: TableColumnsType<IExamStatsByQuestion> = [
      {
        title: t('statistics.placementTest.column8'),
        dataIndex: 'rowIdx'
      },
      {
        title: 'Indicator',
        dataIndex: 'indicator'
      },
      {
        title: 'Skill',
        dataIndex: 'skillName'
      },
      {
        title: 'Total Qs',
        dataIndex: 'totalQs'
      },
      {
        title: t('statistics.placementTest.column11'),
        dataIndex: 'correctAnswerRate'
      },
    ]

    return mainColumns;
  }

  const onExportTable = () => {
    const currentDate = moment(new Date());

    let excelTitle = `${t('statistics.regularTest.title1')}(${t('statistics.regularTest.tab2')}) - ${excelSemesterName} ${excelMonthNameCode}${t('class.class.text26')} ${excelExamDiv} (${excelExamTypeName})`;
    let arrSubTitle = [];

    let courseList = '';
    if(!courseName) {
      selCourseList?.data?.map((item, idx) => {
        if(idx === 0) {
          courseList += item.courseName;  
        } else {
          courseList += ',' + item.courseName;
        }
      });
    } else {
      courseList = courseName;
    }

    arrSubTitle.push(t('statistics.regularTest.placeholder3') + " : " + examSubjectName + (courseList?'(' + courseList + ')':''));
    arrSubTitle.push('Test Students : ' + testStudents);
    arrSubTitle.push('Test Paper : ' + testPaper);

    let tempData: IExamStatsByQuestionBySkill[] = _.cloneDeep(resData);
    tempData.map((item: any) => {
      if(item.correctAnswerRate < 70) {
        item.correctAnswerRate = '|||H|||' + item.correctAnswerRate;
      } else {
        item.correctAnswerRate = item.correctAnswerRate;
      }
    });

    exportTitleTable(getColumns(), tempData, `${t('statistics.regularTest.title1')}(${t('statistics.regularTest.tab2')})_(${currentDate.format('YYYYMMDD')})`, `${t('statistics.regularTest.tab2')}`, [10, 40, 30, 15, 15, 15], excelTitle, arrSubTitle, true);
  }

  return (
    <>
      {isLoading && <Loader />}
      <ErrorResponse error={error} />

      <div className="comm-bx__between">
        <div className="comm-btn__area">
        {data &&
          <>
            <Button 
              className={resultType === EResultType.Table ? 'btn-basic pink-line' : 'btn-basic gray-line'}
              text={t('statistics.regularTest.9')}
              onClick={()=>{ setResultType(EResultType.Table) }}
            ></Button>
            <Button 
              className={resultType === EResultType.Graph ? 'btn-basic pink-line' : 'btn-basic gray-line'}
              text={t('statistics.regularTest.10')}
              onClick={()=>{ setResultType(EResultType.Graph) }}
              disabled={resultType === EResultType.Graph}
            ></Button>
            
          </>
        }
        </div>
        <div className="comm-btn__area right align-items-center">
            {data &&
              (resultType === EResultType.Table && <div className="mt-2">{t('statistics.regularTest.msg2')}</div>)
            }
            <div className="w-150p">
              <SelectExamSubject
                examCode={examCode}
                examSubjectCode={examSubjectCode}
                setExamSubjectCode={setExamSubjectCode}
                setExamSubjectName={setExamSubjectName}
              />
            </div>
            <div className="w-150p">
              <Select
                className="w-100"
                placeholder={t('statistics.dttt.column1')}
                value={courseCode}
                onChange={(value, options) => {
                  setCourseCode(value);
                  Object.entries(options).map(([key, value])=>{
                    if(key === 'courseName') {
                      setCourseName(value);
                    }
                  });
                }}
              >
                <Select.Option value="" courseName=''>{t('common.text.all')}</Select.Option>
                {selCourseList?.data?.map((item) => (
                  <Select.Option key={item.courseCode} value={item.courseCode} courseName={item.courseName}>
                    {item.courseName}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
      </div>
      { resultType === EResultType.Table && <ExamQuestionTable data={data} /> }
      { resultType === EResultType.Graph && <ExamQuestioneGraph data={resData} />}

      {data && resultType === EResultType.Table &&
        <div className="comm-bx__space">
          <DownloadButton onClick={onExportTable} />
        </div>
      }
    </>
  );
};

export default ExamStatsByQuestion;
